import BackDropComponent from "@/components/BackDrop";
import { useBillingCycles } from "@/hooks/useBillingCycles";
import { DownloadWeightDisputeErrorRequest, DownloadWeightDisputeErrorReset, uploadWeightDiscrepancyRequest } from "@/redux/actions";
import { formatDateRangeForBillingCycle } from "@/utils/Common";
import CloseIcon from "@mui/icons-material/Close";
import UploadIcon from "@mui/icons-material/Upload";
import { Box, Button, Divider, Drawer, Grid, IconButton, Typography } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../../../config";
const AddRecordSliderbarPage = ({ isOpen, setIsRightSidebarOpen }) => {
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [uploadedWeightDiscrepancyFile, setUploadedWeightDiscrepancyFile] = React.useState(null);
    const [uploadedCodRemittanceFile, setUploadedCodRemittanceFile] = React.useState(null);
    const billingCycles = useBillingCycles();
    const [selectedBillingCycle, setSelectedBillingCycle] = React.useState(billingCycles[1]);
    const weightDiscrepancyfileUploadState = useSelector((state) => state.weightDiscrepancyfileUploadReducer);
    const codRemittancefileUploadState = useSelector((state) => state.codRemittancefileUploadReducer);
    const downloadErrorFileState = useSelector((state) => state.downloadErrorFileReducer);
    const primaryColor = config.theme.primaryColor;
    const downloadErrorFile = (fileUrl) => {
        setIsBackOpenOpen(true);
        dispatch(DownloadWeightDisputeErrorRequest({
            filePath: fileUrl,
        }));
    };
    const handleDownloadErrorFile = (data, extension) => {
        console.log("exte", extension);
        let type = extension === "pdf"
            ? "application/pdf"
            : extension === "png"
                ? "image/png"
                : extension === "csv"
                    ? "text/csv"
                    : `application/${extension}`;
        const blobData = data instanceof Uint8Array ? new Blob([data], { type }) : data;
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Errorfile.${extension}`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };
    React.useEffect(() => {
        if (downloadErrorFileState.data) {
            setIsBackOpenOpen(false);
            handleDownloadErrorFile(downloadErrorFileState.data, "xlsx");
            dispatch(DownloadWeightDisputeErrorReset());
        }
        else if (downloadErrorFileState.error) {
            enqueueSnackbar("Unable to download file", {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [downloadErrorFileState]);
    useEffect(() => {
        if (weightDiscrepancyfileUploadState.success) {
            enqueueSnackbar("Weight discrepancy file uploaded successfully!", { variant: "success" });
            setIsBackOpenOpen(false);
        }
        else if (weightDiscrepancyfileUploadState.error) {
            enqueueSnackbar(React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "12px", color: "#4B4B4B", fontWeight: 400 } },
                "Failed to upload weight discrepancy file.",
                " ",
                React.createElement("span", { style: { color: "#1976d2", textDecoration: "underline", cursor: "pointer" }, onClick: () => {
                        downloadErrorFile(weightDiscrepancyfileUploadState.error.filePath);
                        closeSnackbar();
                    } },
                    "Click here",
                    " "),
                "to download error file."), {
                variant: "error",
                persist: true,
            });
            setIsBackOpenOpen(false);
        }
        if (codRemittancefileUploadState.success) {
            enqueueSnackbar("COD remittance file uploaded successfully!", { variant: "success" });
            setIsBackOpenOpen(false);
        }
        else if (codRemittancefileUploadState.error) {
            enqueueSnackbar("Failed to upload COD remittance file.", { variant: "error" });
            setIsBackOpenOpen(false);
        }
    }, [
        weightDiscrepancyfileUploadState.success,
        weightDiscrepancyfileUploadState.error,
        codRemittancefileUploadState.success,
        codRemittancefileUploadState.error,
    ]);
    const dispatch = useDispatch();
    const toggleDrawer = () => {
        setIsRightSidebarOpen(false);
    };
    const handleWeightDiscrepancyFileUpload = (event) => {
        const file = event.target.files ? event.target.files[0] : null;
        setUploadedWeightDiscrepancyFile(file);
    };
    const handleWeightDiscrepancyFileUploadClick = () => {
        var _a;
        (_a = document.getElementById("file-input-weight")) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handleFileUpload = () => {
        if (uploadedWeightDiscrepancyFile) {
            setIsBackOpenOpen(true);
            dispatch(uploadWeightDiscrepancyRequest(uploadedWeightDiscrepancyFile));
        }
        else {
            enqueueSnackbar("Please select a file first!", { variant: "warning" });
        }
    };
    const handleDownload = () => {
        const fileUrl = "https://apac-in-reports-bucket-prod.s3.ap-south-1.amazonaws.com/sample-files/Weight_Mismatch.xlsx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "orders_xlsx_upload_india.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (React.createElement(Drawer, { open: isOpen, anchor: "right", onClose: toggleDrawer, PaperProps: { sx: { width: 400 } } },
        React.createElement(Box, { sx: {
                padding: 3,
                backgroundColor: "#f9f9f9",
                height: "100%",
            } },
            React.createElement(BackDropComponent, { open: isBackOpenOpen }),
            React.createElement(Box, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 1 } },
                React.createElement(Typography, { variant: "h6", component: "div", sx: { fontWeight: "bold" } }, "Add Record"),
                React.createElement(IconButton, { onClick: toggleDrawer, size: "small" },
                    React.createElement(CloseIcon, null))),
            React.createElement(Divider, { className: "m_divider" }),
            React.createElement(Box, { sx: { marginBottom: 4, marginTop: 4, display: "flex", alignItems: "center", gap: 2 } },
                React.createElement(Typography, { variant: "body2", sx: {
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "#000000",
                        lineHeight: "21px",
                    } },
                    "Kindly upload the weight file for",
                    " ",
                    React.createElement("span", { style: { fontWeight: 700 } },
                        formatDateRangeForBillingCycle(selectedBillingCycle),
                        " cycle"),
                    ". Shipment charges will be generated only for the ",
                    formatDateRangeForBillingCycle(selectedBillingCycle),
                    " ",
                    "cycle.")),
            React.createElement(Grid, { item: true },
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        width: "325px",
                        height: "40px",
                        border: "1px dashed #121114",
                        borderRadius: "8px",
                        padding: "4px 12px 4px 8px",
                        cursor: "pointer",
                        justifyContent: "space-between",
                    }, onClick: handleDownload },
                    React.createElement(Box, { sx: {
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#f4f4f4",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "10px",
                        } },
                        React.createElement("img", { src: require("../../../assets/Onboarding/FileXls.svg").default, alt: "Xls", style: {
                                width: "36px",
                                height: "36px",
                                marginRight: "8px",
                            } })),
                    React.createElement(Box, { sx: { flexGrow: 1 } },
                        React.createElement(Typography, { sx: { fontSize: "14px", fontWeight: 400, fontFamily: "poppins", color: "#68717D" } }, "Download sample weight file"),
                        React.createElement(Typography, { sx: { fontSize: "10px", fontWeight: 400, fontFamily: "poppins", color: "#5F5A6B" } }, "10 MB")),
                    React.createElement("img", { src: require("../../../assets/Onboarding/Cloud.svg").default, alt: "Xls", style: {
                            width: "24px",
                            height: "24px",
                            marginRight: "8px",
                        } }))),
            React.createElement(Box, { sx: { marginBottom: 3, marginTop: 3 } },
                React.createElement(Button, { fullWidth: true, variant: "outlined", sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textTransform: "none",
                        backgroundColor: "#fff",
                        borderColor: "#121114",
                        color: "#000",
                        "&:hover": {
                            borderColor: "#888",
                            backgroundColor: "#f5f5f5",
                        },
                    }, onClick: handleWeightDiscrepancyFileUploadClick },
                    React.createElement("span", { style: { fontFamily: "poppins", fontWeight: 400, fontSize: "14px", color: "#68717D" } }, "Upload weight discrepancy"),
                    React.createElement(UploadIcon, null)),
                React.createElement("input", { type: "file", id: "file-input-weight", style: { display: "none" }, onChange: handleWeightDiscrepancyFileUpload }),
                uploadedWeightDiscrepancyFile && (React.createElement(Box, { sx: { display: "flex", alignItems: "center", marginTop: 1 } },
                    React.createElement("img", { src: require("../../../assets/Orders/excel.png").default, alt: "excel", style: { width: "40px", marginRight: "10px" } }),
                    React.createElement(Typography, { variant: "caption", sx: { color: "#333" } }, uploadedWeightDiscrepancyFile.name)))),
            React.createElement(Button, { fullWidth: true, variant: "contained", sx: {
                    backgroundColor: primaryColor,
                    color: "#fff",
                    width: "354px",
                    height: "40px",
                    textTransform: "none",
                    padding: 1.5,
                    fontWeight: "bold",
                    "&:hover": {
                        backgroundColor: primaryColor,
                        opacity: 0.9,
                    },
                }, onClick: handleFileUpload }, "Save shipment charges"))));
};
export default AddRecordSliderbarPage;
